import PageTitle from "../../components/PagesComponents/PageTitleSection/PageTitle";

const ChairmanMessage = () => {
  return (
     <><PageTitle pagetitle="CHAIRMAN MESSAGE" />
    <div className=''>
      
      
    </div>
    
    </>


    
  )
}

export default ChairmanMessage